export const CONSENT_EVENT = 'site:cookie-consent';

export function readCookieConsent() {
  try {
    const value = JSON.parse(localStorage.getItem('cookie_consent') || 'null');
    return value && typeof value === 'object' && Number.isFinite(value.expiry) && value.expiry > Date.now() ? value : null;
  } catch { return null; }
}

export function syncClarityConsent() {
  if (!window.clarity) return;
  const consent = readCookieConsent();
  // Microsoft ConsentV2 uses capital S in these parameter names.
  // Unknown/expired/blocked storage is never interpreted as permission.
  window.clarity('consentv2', {
    ad_Storage: consent?.marketing === true ? 'granted' : 'denied',
    analytics_Storage: consent?.analytics === true ? 'granted' : 'denied',
  });
}

export function saveCookieConsent(value) {
  try { localStorage.setItem('cookie_consent', JSON.stringify(value)); } catch { /* optional persistence */ }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}
